import React from 'react';

function Team() {
  return (
    <section className="team">
      <div className="container">
        <h1>👥 Our Team</h1>
        <p className="team-intro">
          Meet the professionals driving innovation at Aashman Technicals
        </p>

        <div className="team-section">
          <h2>🎯 Promoters</h2>
          <div className="promoters-grid">
            <div className="team-card">
              <div className="team-card-header">
                <h3>👨🏻‍💼 Rahul Raverkar</h3>
              </div>
              <p className="team-card-description">
                Highly skilled business strategist and expert in business management with extensive experience at IIM, coupled with innovative technocrat background in leading multinational corporations.
              </p>
            </div>

            <div className="team-card">
              <div className="team-card-header">
                <h3>👨🏻‍💼 Chetan Shinde</h3>
              </div>
              <p className="team-card-description">
                A seasoned product development expert with a background in multinational corporations, driven by a passion for customized solutions and value engineering.
              </p>
            </div>
          </div>
        </div>

        <div className="team-section">
          <h2>⚙️ Core Team</h2>
          <p className="core-team-intro">
            Our team comprises qualified and experienced engineers from diverse technical backgrounds, working together to deliver cutting-edge solutions.
          </p>
          <div className="core-team-grid">
            <div className="core-team-item">
              <h4>🤖 Robotics Engineers</h4>
              <p>Specialized in designing and developing advanced robotic systems for industrial and commercial applications.</p>
            </div>
            <div className="core-team-item">
              <h4>🔌 Embedded Systems Experts</h4>
              <p>Proficient in creating efficient embedded solutions for complex automation challenges.</p>
            </div>
            <div className="core-team-item">
              <h4>🧠 AI & ML Specialists</h4>
              <p>Developing intelligent systems using cutting-edge artificial intelligence and machine learning technologies.</p>
            </div>
            <div className="core-team-item">
              <h4>⚙️ Mechanical Engineers</h4>
              <p>Expert in mechanical design, prototyping, and manufacturing of precision components.</p>
            </div>
            <div className="core-team-item">
              <h4>⚡ Electrical & Electronics Engineers</h4>
              <p>Skilled in circuit design, power systems, and electronic product development.</p>
            </div>
            <div className="core-team-item">
              <h4>💻 Software & IT Engineers</h4>
              <p>Building robust software platforms and IT infrastructure for seamless system integration.</p>
            </div> 
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;